import state from './state'

const rules = function() {
    return {
        counter: value => value.length == 12 || 'Debe ingresar su clave de 12 caractéres',
    }
}

const getUniqueKey = function(){
    return state.uniqueKey
}

export default{
    rules,
    getUniqueKey,
}